(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const selector = '[data-fv-pdp-responsive-disclosure]';

  const syncAll = (root = document) => {
    root.querySelectorAll(selector).forEach((disclosure) => {
      disclosure.open = !mobileQuery.matches;
    });
  };

  mobileQuery.addEventListener?.('change', () => syncAll());
  document.addEventListener('shopify:section:load', (event) => syncAll(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncAll(), { once: true });
  } else {
    syncAll();
  }
})();
